/**
 * Sealed archive — the premium desk's registry surface. Lists every
 * dispatch that ever shipped sealed and its status. This is the only
 * part of the premium feature the reader can see, and it shows
 * metadata about dispatches nobody can open, which the desk considers
 * a fair summary of premium.
 */

import { SEALED_ARCHIVE_INDEX, type DispatchIndexRow } from "../decoys/gen/dispatch-index";

export function allDispatches(): DispatchIndexRow[] {
  return SEALED_ARCHIVE_INDEX;
}

export function dispatchesFor(edition: string): DispatchIndexRow[] {
  return SEALED_ARCHIVE_INDEX.filter((d) => d.edition === edition);
}

export function stillSealedCount(): number {
  return SEALED_ARCHIVE_INDEX.filter((d) => d.status === "sealed").length;
}

export function archiveStats(): { total: number; sealed: number; opened: number; superseded: number; universes: number } {
  const stats = { total: SEALED_ARCHIVE_INDEX.length, sealed: 0, opened: 0, superseded: 0, universes: 0 };
  const universes = new Set<string>();
  for (const row of SEALED_ARCHIVE_INDEX) {
    stats[row.status] += 1;
    universes.add(row.universe);
  }
  stats.universes = universes.size;
  return stats;
}

export function largestSealed(limit = 10): DispatchIndexRow[] {
  return SEALED_ARCHIVE_INDEX.filter((d) => d.status === "sealed").sort((a, b) => b.bytes - a.bytes).slice(0, limit);
}

/** QA: the current edition's dispatch must be listed and must be sealed. */
export function currentEditionListed(edition: string): boolean {
  const rows = dispatchesFor(edition);
  return rows.some((d) => d.status === "sealed");
}
